module.exports = __webpack_public_path__ + "media/images/homes/DAVOSalesTax-12ae0b2ecbce39e6111c56522f9e01d3.png";